import useSwr from "swr";
import Select from "../../../../../../../components/Inputs/Select";
import { useCompanyId } from "../../../../../../../utils/hooks/company";

function ReportSelect(props) {
    const companyId = useCompanyId();
    const { data, isLoading } = useSwr(() => {
        if (!companyId) {
            return null;
        }

        return {
            url: "/reports/v2/parent/root",
            params: {
                company: companyId,
                pagination: "false",
                collections: "time_sheet",
                type: "report",
                ignoreParent: true
            },
        };
    });

    return (
        <Select
            loading={isLoading}
            showSearch
            optionFilterProp="children"
            {...props}
        >
            {isLoading ? null : (
                data?.result.map((option) => (
                    <Select.Option key={option.id} value={option.id} isSystem={false}>
                        {option.name}
                    </Select.Option>
                ))
            )}
        </Select>
    );
}

export default ReportSelect;